var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "MyDrag",
    {
      key: "1",
      staticClass: "drag-resize-container",
      attrs: {
        id: "drag-resize-container",
        x: _vm.initialX,
        y: 55,
        w: 432,
        h: 100,
      },
    },
    [
      _c("template", { slot: "default" }, [
        _c(
          "div",
          { staticClass: "slideBar-container" },
          [_c("ordinarySlide")],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }